function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { Component } from 'react';
import classNames from 'classnames';
import { Button, Checkbox, Select } from '@deephaven/components';
import Log from '@deephaven/log';
import { DbNameValidator } from '@deephaven/utils';
import CsvOverlay from "./CsvOverlay.js";
import CsvParser from "./CsvParser.js";
import CsvFormats from "./CsvFormats.js";
import "./CsvInputBar.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('CsvInputBar');
var TYPE_OPTIONS = Object.entries(CsvFormats.TYPES).map(_ref => {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  return /*#__PURE__*/_jsx("option", {
    value: key,
    children: value.name
  }, key);
});
/**
 * Input controls for CSV upload.
 */
class CsvInputBar extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "inputRef", void 0);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleTableName = this.handleTableName.bind(this);
    this.toggleFirstRowHeaders = this.toggleFirstRowHeaders.bind(this);
    this.handleProgress = this.handleProgress.bind(this);
    this.handleCancelInProgress = this.handleCancelInProgress.bind(this);
    this.handleQueryTypeChange = this.handleQueryTypeChange.bind(this);
    this.inputRef = /*#__PURE__*/React.createRef();
    this.state = {
      tableName: '',
      tableNameSet: false,
      isFirstRowHeaders: true,
      showProgress: false,
      progressValue: 0,
      type: CsvFormats.DEFAULT_TYPE,
      parser: null
    };
  }

  // React documentation says it is fine to update state inside an if statment
  /* eslint-disable react/no-did-update-set-state */
  componentDidUpdate(prevProps) {
    var _this$props = this.props,
      file = _this$props.file,
      paste = _this$props.paste;
    var _this$state = this.state,
      tableName = _this$state.tableName,
      tableNameSet = _this$state.tableNameSet;
    // Set the table name from a file
    if (!tableNameSet && file != null && !tableName) {
      var _this$inputRef$curren;
      var dotIndex = file.name.lastIndexOf('.');
      var fileTableName = DbNameValidator.makeVariableName(file.name.substring(0, dotIndex));
      this.setState({
        tableName: fileTableName,
        tableNameSet: true
      });
      (_this$inputRef$curren = this.inputRef.current) === null || _this$inputRef$curren === void 0 || _this$inputRef$curren.focus();
    } else if (file == null && prevProps.file != null || paste == null && prevProps.paste != null) {
      // The file or paste was unstaged
      this.setState({
        tableName: '',
        tableNameSet: false
      });
    }

    // Focus the name input field on paste
    if (paste != null && paste !== '' && !tableName && this.inputRef.current) {
      this.inputRef.current.focus();
    }

    // Determine parser type by file extension
    if (file != null && file !== prevProps.file) {
      this.setState({
        type: CsvFormats.fromExtension(file.name)
      });
    } else if (paste != null && paste !== '' && (prevProps.paste === undefined || prevProps.paste === '')) {
      this.setState({
        type: CsvFormats.AUTO
      });
    }
  }
  componentWillUnmount() {
    var parser = this.state.parser;
    if (parser) {
      parser.cancel();
    }
  }
  handleCancel() {
    var onClose = this.props.onClose;
    onClose();
  }
  handleError(e) {
    var _this$props2 = this.props,
      onClose = _this$props2.onClose,
      onError = _this$props2.onError;
    log.error(e);
    onError(e);
    onClose();
  }
  handleTableName(event) {
    this.setState({
      tableName: event.target.value,
      tableNameSet: true
    });
  }
  toggleFirstRowHeaders() {
    var isFirstRowHeaders = this.state.isFirstRowHeaders;
    this.setState({
      isFirstRowHeaders: !isFirstRowHeaders
    });
  }
  handleUpload(event) {
    event.stopPropagation();
    event.preventDefault();
    var _this$props3 = this.props,
      file = _this$props3.file,
      paste = _this$props3.paste;
    if (file != null) {
      if (file.name.endsWith('.zip')) {
        this.handleZipFile(file);
      } else {
        this.handleFile(file);
      }
    } else if (paste !== undefined && paste !== '') {
      this.handleFile(new Blob([paste], {
        type: 'text/plain'
      }));
    }
  }
  handleFile(file) {
    var isZip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    log.info("Starting CSV parser for ".concat(file instanceof File ? file.name : 'pasted values', " ").concat(isZip ? '' : file.size, " bytes"));
    var _this$props4 = this.props,
      session = _this$props4.session,
      timeZone = _this$props4.timeZone,
      onInProgress = _this$props4.onInProgress;
    var _this$state2 = this.state,
      tableName = _this$state2.tableName,
      isFirstRowHeaders = _this$state2.isFirstRowHeaders,
      type = _this$state2.type;
    var handleParseDone = tables => {
      // Do not bother merging just one table
      if (tables.length === 1) {
        session.bindTableToVariable(tables[0], tableName).then(() => this.openTable()).catch(e => this.handleError(e));
      } else {
        session.mergeTables(tables).then(table => {
          session.bindTableToVariable(table, tableName).then(() => this.openTable()).catch(e => this.handleError(e));
          tables.forEach(t => t.close());
        }).catch(e => this.handleError(e));
      }
    };
    var parser = new CsvParser({
      onFileCompleted: handleParseDone,
      session,
      file,
      type: CsvFormats.TYPES[type],
      readHeaders: isFirstRowHeaders,
      onProgress: this.handleProgress,
      onError: this.handleError,
      timeZone,
      isZip
    });
    parser.parse();
    this.setState({
      showProgress: true,
      parser
    });
    // Note that calling onClose will set in progress to false
    onInProgress(true);
  }
  handleZipFile(zipFile) {
    var _this$props5 = this.props,
      onUpdate = _this$props5.onUpdate,
      unzip = _this$props5.unzip;
    if (unzip == null) {
      this.handleError(new Error('No support for zip files available.'));
      return;
    }
    unzip(zipFile).then(files => {
      var csvFound = false;
      // Find the first Csv file in the zip and use that
      for (var i = 0; i < files.length; i += 1) {
        var f = files[i];
        if (CsvOverlay.isValidExtension(f.name)) {
          onUpdate("Loading ".concat(f.name, " as csv from ").concat(zipFile.name));
          csvFound = true;
          this.handleFile(f, true);
          break;
        }
      }
      if (!csvFound) {
        throw new Error("No csv file found in ".concat(zipFile.name));
      }
    }).catch(e => this.handleError(e));
  }
  handleProgress(progressValue) {
    var showProgress = this.state.showProgress;
    if (showProgress) {
      this.setState({
        progressValue
      });
    }
    // Indicates to the caller that the upload has been cancelled
    return !showProgress;
  }

  // Cancels an in progress upload
  handleCancelInProgress() {
    var onInProgress = this.props.onInProgress;
    var parser = this.state.parser;
    if (parser) {
      parser.cancel();
    }
    this.setState({
      showProgress: false,
      progressValue: 0
    });
    onInProgress(false);
  }
  openTable() {
    var _this$props6 = this.props,
      onOpenTable = _this$props6.onOpenTable,
      onClose = _this$props6.onClose;
    var tableName = this.state.tableName;
    onOpenTable(tableName);
    onClose();
  }
  handleQueryTypeChange(eventTargetValue) {
    this.setState({
      type: eventTargetValue
    });
  }
  render() {
    var _this$props7 = this.props,
      file = _this$props7.file,
      paste = _this$props7.paste;
    var _this$state3 = this.state,
      tableName = _this$state3.tableName,
      isFirstRowHeaders = _this$state3.isFirstRowHeaders,
      showProgress = _this$state3.showProgress,
      progressValue = _this$state3.progressValue,
      type = _this$state3.type;
    // A blank table name is invalid for pasted values
    var isNameInvalid = Boolean(paste) && !tableName;
    return /*#__PURE__*/_jsxs("div", {
      className: "csv-input-bar",
      children: [!showProgress && /*#__PURE__*/_jsxs("form", {
        onSubmit: this.handleUpload,
        className: "csv-input-bar-container form-inline",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "form-group",
          children: [/*#__PURE__*/_jsx("label", {
            htmlFor: "tableNameInput",
            children: "Table name"
          }), /*#__PURE__*/_jsx("input", {
            ref: this.inputRef,
            id: "tableNameInput",
            type: "text",
            className: classNames('form-control', {
              'is-invalid': isNameInvalid
            }),
            value: tableName,
            onChange: this.handleTableName
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "form-group",
          children: [/*#__PURE__*/_jsx("label", {
            htmlFor: "formatSelect",
            children: "File format"
          }), /*#__PURE__*/_jsx(Select, {
            id: "formatSelect",
            className: "custom-select",
            value: type,
            onChange: this.handleQueryTypeChange,
            children: TYPE_OPTIONS
          })]
        }), /*#__PURE__*/_jsx(Checkbox, {
          className: "firstRowHeaders",
          checked: isFirstRowHeaders,
          onChange: this.toggleFirstRowHeaders,
          children: "First row is column headers"
        }), /*#__PURE__*/_jsxs("div", {
          className: "csv-input-buttons form-group",
          children: [/*#__PURE__*/_jsx(Button, {
            kind: "secondary",
            onClick: this.handleCancel,
            children: "Cancel"
          }), /*#__PURE__*/_jsx(Button, {
            kind: "primary",
            type: "submit",
            disabled: !(file !== null || paste !== undefined && paste !== '') || !tableName,
            children: "Upload"
          })]
        })]
      }), showProgress && /*#__PURE__*/_jsxs("div", {
        className: "csv-progress-container",
        children: [/*#__PURE__*/_jsx("label", {
          children: "Uploading Table"
        }), /*#__PURE__*/_jsx("div", {
          className: "progress",
          children: /*#__PURE__*/_jsx("div", {
            className: "progress-bar bg-primary",
            style: {
              width: "".concat(progressValue, "%")
            },
            "aria-valuenow": progressValue,
            "aria-valuemin": 0,
            "aria-valuemax": 100
          })
        }), /*#__PURE__*/_jsxs("label", {
          children: [progressValue, "%"]
        }), /*#__PURE__*/_jsx(Button, {
          kind: "primary",
          onClick: this.handleCancelInProgress,
          children: "Cancel"
        })]
      })]
    });
  }
}
_defineProperty(CsvInputBar, "defaultProps", {
  file: null,
  paste: null,
  unzip: null
});
export default CsvInputBar;
//# sourceMappingURL=CsvInputBar.js.map